import Vue from 'vue'

let stati = [
  {
    label: 'Invio',
    id: 'sent',
    num: 0,
    icon: 'icon-send',
  },
  {
    label: 'Compilazione',
    id: 'compilato',
    num: 1,
    icon: 'icon-edit-2',
  },
  {
    label: 'Analisi',
    id: 'analisi',
    num: 2,
    icon: 'icon-settings',
  },
  {
    label: 'Inserimento convenzione e progetto',
    id: 'convenzione',
    num: 3,
    icon: 'icon-codepen',
  },
  {
    label: 'Firma Azienda',
    id: 'azienda',
    num: 4,
    icon: 'icon-grid',
  },
  {
    label: 'Firma Tirocinante',
    id: 'tirocinante',
    num: 5,
    icon: 'icon-award',
  },
  {
    label: 'Firma Ente Certificatore',
    id: 'certificatore',
    num: 6,
    icon: 'icon-briefcase',
  },
  {
    label: 'Firma Ente Promotore',
    id: 'promotore',
    num: 7,
    icon: 'icon-command',
  },
  {
    label: 'Portale ER',
    id: 'portale_er',
    num: 8,
    icon: 'icon-bookmark',
  },
  {
    label: 'Comunicazione SARE',
    id: 'com_sare',
    num: 9,
    icon: 'icon-aperture',
  },
  {
    label: 'Approvazione regione',
    id: 'appr_regione',
    num: 10,
    icon: 'icon-cloud',
  },
  {
    label: 'Completato',
    id: 'complete',
    num: 11,
    icon: 'icon-target',
  },
  {
    label: 'Sospeso',
    id: 'pause',
    num: 12,
    color: 'warning',
    icon: 'icon-pause',
  },
  {
    label: 'Riattiva',
    id: 'restart',
    num: 13,
    color: 'success',
    icon: 'icon-loader',
  },
  {
    label: 'Cessato',
    id: 'stop',
    num: 14,
    color: 'danger',
    icon: 'icon-x-circle',
  },
  {
    label: 'Proroga',
    id: 'more',
    num: 15,
    icon: 'icon-more-horizontal',
  },
  {
    label: 'Annulato',
    id: 'cancelled',
    num: 16,
    icon: 'icon-trending-down',
  },
]

Vue.prototype.$tir = {
  stati,
  label_of: id => stati.find(x => x.id == id).label,
  icon_of: id => stati.find(x => x.id == id).icon,
  label_of_next(stato) {
    let i = this.index_of(stato)
    return stati[i+1].label
  },
  index_of: id => stati.findIndex(x => x.id == id),

  contract_types: {
    det: 'Determinato',
    indet: 'Indeterminato',
    piva: 'Consulente',
    tit: 'Titolare',
  },
  studio_types: {
    medie: 'Licenza media',
    diploma: 'Diploma',
    laurea: 'Laurea',
    master: 'Master',
  },

  formatDateNew(date) {
    date = new Date(date)
    var options = { year: "numeric", month: "short", day: "numeric" }
    return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
  },

  generatePDFtirocinio(tiroc,uffici_string) {
    let p_to_print = {...tiroc}
    // console.log(uffici_string);

    p_to_print['data_inserimento'] = this.formatDateNew(p_to_print['data_inserimento'])
    p_to_print['data_inizio_date'] = p_to_print['data_inizio'] ? p_to_print['data_inizio'] : ''
    p_to_print['data_inizio'] = p_to_print['data_inizio'] ? this.formatDateNew(p_to_print['data_inizio']) : ''
    p_to_print['data_fine_date'] = p_to_print['data_fine'] ? p_to_print['data_fine'] : ''
    p_to_print['data_fine'] = p_to_print['data_fine'] ? this.formatDateNew(p_to_print['data_fine']) : ''
    p_to_print['tiroc_birth_date'] = p_to_print['tiroc_birth_date'] ? this.formatDateNew(p_to_print['tiroc_birth_date']) : ''

    p_to_print['azienda']['codice_ufficio'] = uffici_string
    p_to_print['azienda']['contatti'] = p_to_print['azienda']['contatti'] ? p_to_print['azienda']['contatti'].filter( c => { c.id_ruolo == 93 || c.id_ruolo == 1 }) : []
    if (p_to_print['azienda']['contatti'] > 1) p_to_print['azienda']['contatti'].pop()
    // p_to_print['indennita'] = (new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2 })).format(p_to_print['indennita'])

      // console.log(p_to_print);
    return p_to_print
  },
}
